import React from "react"
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@material-ui/core"
import CloseIcon from "@material-ui/icons/Close"

const CustomModal = ({
  isOpen,
  closeModal,
  children,
  title = "",
  paperClassName = "",
}) => (
  <Dialog
    open={isOpen}
    onClose={closeModal}
    fullWidth
    maxWidth="md"
    PaperProps={{ className: paperClassName }}
    aria-labelledby="custom-modal-title"
  >
    <DialogTitle disableTypography>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        gridGap={16}
      >
        <Typography id="custom-modal-title" component="h2" variant="h4">
          {title || "Detalle"}
        </Typography>
        <IconButton onClick={closeModal} aria-label="Cerrar" size="small">
          <CloseIcon />
        </IconButton>
      </Box>
    </DialogTitle>
    <DialogContent>
      <Box
        bgcolor="white"
        border="1px solid #dce4ef"
        borderRadius={9}
        p={2}
        mb={1}
      >
        {children}
      </Box>
    </DialogContent>
  </Dialog>
)

export default CustomModal
